// client/src/pages/SignedInStudent/SignedInStudent.jsx
import { useEffect, useState } from "react";
import "./SignedInStudent.css";
import axios from "axios";
import API_BASE_URL from "../../apiConfig";

export default function SignedInStudent() {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const url = `${API_BASE_URL}`;

  const fetch = async () => {
    try {
      const response = await axios.get(`${url}/signinTracker`);
      setData(
        response.data.map((student) => ({
          ...student,
          formattedSignInTime: formatSignInTime(student.SignInTime),
          duration: calculateDuration(student.SignInTime),
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const SignAllOut = async () => {
    try {
      await axios.delete(`${url}/signinTracker/signallout`);
      fetch();
    } catch (error) {
      console.error("Error signing all out:", error);
    }
  };

  const signOutById = async (studentId) => {
    try {
      await axios.delete(`${url}/signinTracker/${studentId}`);
      fetch();
    } catch (error) {
      console.error("Error signing out student:", error);
      alert("Failed to sign out student. Please try again.");
    }
  };

  const exportToCSV = () => {
    const headers = "Name,Signed In,Duration\n";
    const rows = data.map((student) =>
      `"${student.name}","${student.formattedSignInTime}","${student.duration}"`
    ).join("\n");
    const csv = headers + rows;
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "signed_in_students.csv";
    link.click();
  };

  const formatSignInTime = (signInTime) => {
    const date = new Date(signInTime);
    return date.toLocaleString();
  };

  const calculateDuration = (signInTime) => {
    const signInDate = new Date(signInTime);
    const now = new Date();
    const duration = now - signInDate;
    return formatDuration(duration);
  };

  const formatDuration = (milliseconds) => {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    seconds = seconds % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m ${seconds}s`;
  };

  const filteredData = data.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="signedInStudent">
      <div className="container">
        <h1 className="title">Signed-In Students</h1>
        <div className="button-group">
          <button className="signout-btn" onClick={SignAllOut}>
            Sign All Out
          </button>
          <button className="refresh-btn" onClick={fetch}>
            Refresh
          </button>
          <button className="export-btn" onClick={exportToCSV}>
            Export to CSV
          </button>
        </div>
        <input
          type="text"
          className="search-input"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {filteredData.length > 0 ? (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Signed In</th>
                  <th>Duration</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((student) => (
                  <tr key={student.studentID}>
                    <td>{student.name}</td>
                    <td>{student.formattedSignInTime}</td>
                    <td>{student.duration}</td>
                    <td>
                      <button
                        className="signout-individual-btn"
                        onClick={() => signOutById(student.studentID)}
                      >
                        Sign Out
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-students">No students match your search</p>
        )}
      </div>
    </div>
  );
}